/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust3_PInputs */

const es_landing_trust3_p = /** @type {(inputs: Landing_Trust3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión plana + IVA. La misma para todas las modalidades.`)
};

const gl_landing_trust3_p = /** @type {(inputs: Landing_Trust3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión plana + IVE. A mesma para todas as modalidades.`)
};

const en_landing_trust3_p = /** @type {(inputs: Landing_Trust3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flat commission + VAT. The same for every option.`)
};

/**
* | output |
* | --- |
* | "Flat commission + VAT. The same for every option." |
*
* @param {Landing_Trust3_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust3_p = /** @type {((inputs?: Landing_Trust3_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust3_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust3_p(inputs)
	if (locale === "en") return en_landing_trust3_p(inputs)
	return es_landing_trust3_p(inputs)
});